// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import copy01Icon from "@/assets/icons/copy-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Copy01IconProps = Omit<IconProps, "name">;

export function Copy01Icon(props: Copy01IconProps): React.ReactNode {
  return <Icon name={copy01Icon} {...props} />;
}
